import React, { FC, useEffect, useState } from "react";
import { Upload, Row, Col, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { UPLOAD_MEDIA } from "../../reducers/reducer";
import { RootState } from "reducers/rootReducer";
import { uuid } from "uuidv4";

const FileUpload: FC<{
  value?: number;
  onChange: any;
  placeholder?: any;
  isMobile?: any;
  onUploadClick?: any;
}> = ({ value, onChange, placeholder, isMobile, onUploadClick }) => {
  const [file, setFile] = useState<any>(value);
  const dispatch = useDispatch();
  const { fileToSend } = useSelector((state: RootState) => state.auth);
  const [saving, setSaving] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<any>();

  useEffect(() => {
    if (fileToSend) {
      const image = {
        name: fileToSend.media.originalName,
        url: fileToSend.media.urls.original.url,
        ...fileToSend.media,
      };
      setFile(image);
      setSaving(false);
      onChange(image);
      dispatch({ type: "ADD_FILE", payload: undefined });
    }
  }, [fileToSend, requestId]);

  const handleOk = () => {
    let form = new FormData();
    form.append("file", file);
    form.append("info", JSON.stringify({}));
    const id = uuid();
    dispatch(UPLOAD_MEDIA({ form, id }));
    setSaving(true);
    // setRequestId(id);
  };

  const onCancel = () => {
    setFile(null);
    onChange(null);
  };

  useEffect(() => {
    setFile(value);
  }, [value]);

  return (
    <Row className="custom-file-upload">
      <Col span={24}>
        {(file && file.name) ? (
          <div className="file-wrapper">
            <p>Your dropped file:</p>
            <hr />
            <ul>
              <li>
                <a target="_blank" href={file.url}>
                  {file.name}
                </a>
                <CloseOutlined onClick={() => onCancel()} />
              </li>
            </ul>
            {!file.url && (
              <Row className="action-grp mt-4">
                <Col span={24} className="pr-2">
                  <Button
                    className="beam-btn cover w-full"
                    onClick={handleOk}
                    loading={saving}
                  >
                    Upload
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <div>
            {isMobile ? (
              <div className="file-wrapper">
                <div className="d-flex flex-column justify-content-center align-items-center p-4 cursor-pointer" onClick={()=>{
                  if(onUploadClick)onUploadClick();
                }}>
                  <p>Click to upload file</p>
                </div>
              </div>
            ) : (
              <Upload
                maxCount={1}
                beforeUpload={async (file, fileList) => {
                  setFile(file);
                  setRequestId(uuid());
                  return false;
                }}
              >
                <div>{placeholder || `Drop your file here (or click)`}</div>
              </Upload>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default FileUpload;
